import { axiosAjax } from './common'
export default {
  // 获取文档列表
  getDocumentList (params) {
    return axiosAjax('/file_manage', 'get', params)
  },
  // 删除文件
  delDocument (params) {
    return axiosAjax('/file/manage', 'delete', {data: params})
  },
  // 文件上传
  uploadFile (params) {
    return axiosAjax('/file/manage', 'post', {data: params})
  }
}



// WEBPACK FOOTER //
// ./src/api/document.js